import React, { useState } from "react";
import { ButtonGroup, ToggleButton } from "react-bootstrap";
import OldReturnEarnings from "./OldReturnEarnings";
import NewReturnEarnings from "./NewReturnEarnings";

const VERSIONS = [
  { name: "Old", value: "old" },
  { name: "New", value: "new" },
];

function ReturnEarnings({ authrztn }) {
  const [version, setVersion] = useState("new");

  return (
    <div className="h-100 w-100 d-flex flex-column">
      <div className="d-flex justify-content-end p-2">
        {/* <ButtonGroup>
          {VERSIONS.map((item) => (
            <ToggleButton
              key={item.value}
              id={`return-earnings-toggle-${item.value}`}
              type="radio"
              variant={version === item.value ? "primary" : "outline-primary"}
              name="return-earnings-version"
              value={item.value}
              checked={version === item.value}
              onChange={(e) => setVersion(e.currentTarget.value)}
            >
              {item.name}
            </ToggleButton>
          ))}
        </ButtonGroup> */}
      </div>

      <div className="flex-grow-1">
        {version === "old" ? (
          <OldReturnEarnings authrztn={authrztn} />
        ) : (
          <NewReturnEarnings authrztn={authrztn} />
        )}
      </div>
    </div>
  );
}

export default ReturnEarnings;
